var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 18.75v13.5h-6V27H12v5.25H6v-13.5m24 0V6H6v12.75m24 0H6M6 27h24",
    stroke: "#181818",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.188 24.528a1.688 1.688 0 100-3.375 1.688 1.688 0 000 3.375zM23.813 24.528a1.688 1.688 0 100-3.375 1.688 1.688 0 000 3.375zM0 9h3v6H0zM33 9h3v6h-3z",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMwIDE4Ljc1VjMyLjI1SDI0VjI3SDEyVjMyLjI1SDZWMTguNzVNMzAgMTguNzVWMTQuODEyNVYxMC44NzVWNkw2IDZWMTAuODc1VjE4Ljc1TTMwIDE4Ljc1SDE4SDYiIHN0cm9rZT0iIzE4MTgxOCIgc3Ryb2tlLXdpZHRoPSIzIi8+CjxwYXRoIGQ9Ik02IDI3TDMwIDI3IiBzdHJva2U9IiMxODE4MTgiIHN0cm9rZS13aWR0aD0iMyIvPgo8cGF0aCBkPSJNMTIuMTg3NSAyNC41MjhDMTMuMTE5NSAyNC41MjggMTMuODc1IDIzLjc3MjQgMTMuODc1IDIyLjg0MDVDMTMuODc1IDIxLjkwODUgMTMuMTE5NSAyMS4xNTMgMTIuMTg3NSAyMS4xNTNDMTEuMjU1NSAyMS4xNTMgMTAuNSAyMS45MDg1IDEwLjUgMjIuODQwNUMxMC41IDIzLjc3MjQgMTEuMjU1NSAyNC41MjggMTIuMTg3NSAyNC41MjhaIiBmaWxsPSIjMTgxODE4Ii8+CjxwYXRoIGQ9Ik0yMy44MTI1IDI0LjUyOEMyNC43NDQ1IDI0LjUyOCAyNS41IDIzLjc3MjQgMjUuNSAyMi44NDA1QzI1LjUgMjEuOTA4NSAyNC43NDQ1IDIxLjE1MyAyMy44MTI1IDIxLjE1M0MyMi44ODA1IDIxLjE1MyAyMi4xMjUgMjEuOTA4NSAyMi4xMjUgMjIuODQwNUMyMi4xMjUgMjMuNzcyNCAyMi44ODA1IDI0LjUyOCAyMy44MTI1IDI0LjUyOFoiIGZpbGw9IiMxODE4MTgiLz4KPHJlY3QgeT0iOSIgd2lkdGg9IjMiIGhlaWdodD0iNiIgZmlsbD0iIzE4MTgxOCIvPgo8cmVjdCB4PSIzMyIgeT0iOSIgd2lkdGg9IjMiIGhlaWdodD0iNiIgZmlsbD0iIzE4MTgxOCIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };